import { render, staticRenderFns } from "./SponsoringUnitModalComponent.vue?vue&type=template&id=412194e4&"
import script from "./SponsoringUnitModalComponent.vue?vue&type=script&lang=ts&"
export * from "./SponsoringUnitModalComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('412194e4')) {
      api.createRecord('412194e4', component.options)
    } else {
      api.reload('412194e4', component.options)
    }
    module.hot.accept("./SponsoringUnitModalComponent.vue?vue&type=template&id=412194e4&", function () {
      api.rerender('412194e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/Unit/SponsoringUnitModalComponent.vue"
export default component.exports